/* ──────────────────────────────────────────────────────────────────────
   LegalPage — shared component for /privacy/ and /terms/
   ──────────────────────────────────────────────────────────────────────
   Renders a long-form legal document from window.DZ_LEGAL[which]:
     - which="privacy"  → /privacy/  → Privacy Policy
     - which="terms"    → /terms/    → Terms of Use

   Layout pattern:
     1. Compact navy hero with eyebrow / title / effective date / intro
     2. Light-grey body with numbered sections (heading + body para)
     3. Editorial measure (max 68ch) so long lines stay readable
     4. Same Navbar + Footer chrome as the rest of the site

   Why one component instead of two: the structure is identical, only the
   data differs. This keeps the JSX short and means a future "Cookies"
   page would just need an entry in legal.js + a slim index.html.
   ─────────────────────────────────────────────────────────────────── */

/* ── Arabic localization helpers (path-based; EN branch byte-identical) ── */
function dzIsAr() { return typeof window !== 'undefined' && window.location.pathname.startsWith('/ar/'); }
function dzT(en, ar) { return dzIsAr() ? ar : en; }

function LegalPage({ which }) {
  const data = (window.DZ_LEGAL || {})[which];
  if (!data) return null;

  return (
    <main className="dz-legal" id="dz-main">
      <header className="dz-legal__hero">
        <div className="dz-legal__hero-inner">
          <p className="dz-legal__eyebrow">{data.eyebrow}</p>
          <h1 className="dz-legal__title">{data.title}</h1>
          <p className="dz-legal__effective">
            <span className="dz-legal__effective-label">{data.effectiveLabel || 'Effective:'}</span>
            {' '}{data.effectiveDate}
          </p>
          {data.intro && (
            <p className="dz-legal__intro">{data.intro}</p>
          )}
        </div>
      </header>

      <article className="dz-legal__body">
        <div className="dz-legal__body-inner">
          {data.sections.map((section, i) => (
            <section className="dz-legal__section" key={i}>
              <h2 className="dz-legal__section-h">{section.heading}</h2>
              <p className="dz-legal__section-p">{section.body}</p>
            </section>
          ))}

          <p className="dz-legal__sig">
            {dzT('For questions about this ', 'للاستفسارات حول ')}{data.title.toLowerCase()}{dzT(', contact', '، تواصل عبر')}{' '}
            <a className="dz-legal__sig-link" href="mailto:info@designzone.com.sa">
              info@designzone.com.sa
            </a>.
          </p>
        </div>
      </article>
    </main>
  );
}
